import { Divider } from "@mui/material";

export function TooltipContentDivider() {
    return (
        <Divider sx={{borderColor: 'lightgrey', borderWidth: '1px', my: '3px'}}/>
    )
}